import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl, useSelector, statusLoading, idleState } from '@grandvisionhq/state';
import { useConfiguratorContext } from '../../../../Context/ConfiguratorContext.js';
import { usePrivateSteppingContext } from '../../../../Context/PrivateSteppingContext.js';
import { useSteps } from '../../../../hooks/use-steps.js';
import { isLastStep, getFinishCall } from '../../../../state/selectors.js';
import { CallToAction } from './CallToAction.js';

const DEFAULT_CTA_LABEL_KEY = 'products.glasses.configurator.footer.CTA';
const CallToActionContainer = ()=>{
    const { getLabel  } = useIntl();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { configuratorId , onTriggerDataLayer  } = useConfiguratorContext();
    const { lastStepCTALabelKey , selectorProps  } = usePrivateSteppingContext();
    const { steps , currentStepIndex , currentStep  } = useSteps();
    const { labelKeys  } = currentStep;
    const fallbackCtaLabel = {
        key: labelKeys.alternativeCta || DEFAULT_CTA_LABEL_KEY,
        value: undefined,
        overrideLastCta: false
    };
    const isOnLastStep = useSelector((s)=>isLastStep(s, selectorProps)
    );
    const ctaLabel = useSelector((s)=>currentStep.ctaLabel ? currentStep.ctaLabel(s, {
            defaultCtaLabel: DEFAULT_CTA_LABEL_KEY,
            alternativeCtaLabel: labelKeys.alternativeCta
        }) : fallbackCtaLabel
    );
    const finishCall = useSelector((s)=>getFinishCall(s, {
            id: configuratorId
        })
    );
    const labelValue = React.useMemo(()=>{
        if (isOnLastStep && !ctaLabel.overrideLastCta) return getLabel(lastStepCTALabelKey);
        if (ctaLabel.value) return ctaLabel.value;
        if (ctaLabel.key) return getLabel(ctaLabel.key);
        return getLabel(fallbackCtaLabel.key);
    }, [
        isOnLastStep,
        getLabel,
        ctaLabel
    ]);
    const handleClick = ()=>{
        onTriggerDataLayer({
            steps,
            currentStepIndex,
            eventType: 'rx_next_step_click',
            eventCategory: configuratorId === 'rxSun' ? 'rx_sunglasses' : 'rx_glasses'
        });
    };
    return /*#__PURE__*/ React.createElement(CallToAction, {
        label: labelValue,
        isLoading: statusLoading(finishCall || idleState()),
        isSmallScreen: isSmallScreen,
        formId: configuratorId,
        onClick: handleClick
    });
};

export { CallToActionContainer };
//# sourceMappingURL=CallToActionContainer.js.map
